import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import animationData from "../../assets/img/animated-icons/check-primary-light.json";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

const SuccessModal = ({
  modal,
  setModal,
  title,
  description,
  price = false,
  pract = false,
  branch = false,
  empolyee = false,
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      show={modal}
      onHide={() => {
        setModal(false);
        if (pract) {
          navigate("/practitioner/practitioner-list");
        }
        if (price) {
          navigate(paths.priceList);
        }
        if (branch) {
          navigate(paths.branchList);
        }
        if (empolyee) {
          navigate(paths.employeeList);
        }
      }}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Body>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={() => {
            setModal(!modal);
            if (pract) {
              navigate("/practitioner/practitioner-list");
            }
            if (price) {
              navigate(paths.priceList);
            }
            if (branch) {
              navigate(paths.branchList);
            }
            if (empolyee) {
              navigate(paths.employeeList);
            }
          }}
        />
        <Flex justifyContent="center" alignItems="center">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px" }}
          />
          <div className="mb-0 flex-1 d-flex flex-column">
            <h6 className="fs-8">{title}</h6>
            <h6 className="fs-10">{description}</h6>
          </div>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

SuccessModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
};

export default SuccessModal;
